<template>
  <div class="home">
    <!-- 成绩查询 悬浮窗 -->
    <!-- <div class="queryFixed" @click="queryList"><p>成绩查询</p></div> -->
    <!-- 顶部轮播图 -->
    <div class="maininfo">
      <!-- <el-carousel :autoplay = "true" :interval="15000" > -->
      <el-carousel v-if="imgone.length > 0" :autoplay="true" :interval="10000" height="375px" style="width:100%;max-width:1440px">
        <el-carousel-item v-for="item in imgone" :key="item.bannerId">
          <img :src="item.imgPath" alt="" @click="topage(item)" />
        </el-carousel-item>
      </el-carousel>
      <!-- <el-carousel indicator-position="outside" 指示器的位置在外面 >-->
    </div>

    <!-- 协会公告 -->
    <!-- 新闻资讯 -->
    <div class="listinfo">
      <div class="widthSet">
        <div class="left">
          <div class="top">
            <div class="leftson">
              <h3>协会公告</h3>
              <p>
                <span>ASSOCIATION</span> <span class="green">ANNOUNCEMENT</span>
              </p>
            </div>
            <div class="rightson">
              <p>更多</p>
              <button @click="tonotice">
                <i class="el-icon-arrow-right"></i>
              </button>
            </div>
          </div>

          <ul class="newnotice">
            <li
              class="itemshadow aniMate"
              v-for="item in noticelist"
              :key="item.noticeId"
              @click="getnoticedetailsdata(item)"
            >
              <p class="maxwidth">{{ item.title }}</p>
              <p>{{ item.publishDate }}</p>
            </li>
            <li v-if="noticelist.length === 0" class="itemshadow">
              <p>暂无协会公告</p>
            </li>
          </ul>
        </div>

        <!-- 新闻资讯 -->
        <div class="right">
          <div class="top">
            <div class="leftson">
              <h3>新闻资讯</h3>
              <p><span class="green">NEWS</span></p>
            </div>
            <div class="rightson">
              <p>更多</p>
              <button @click="tonews">
                <i class="el-icon-arrow-right"></i>
              </button>
            </div>
          </div>

          <ul class="newnotice">
            <li
              class="itemshadow aniMate"
              v-for="item in newslist"
              :key="item.id"
              @click="getnewsdetailsdata(item)"
            >
              <p class="maxwidth">{{ item.title }}</p>
              <p>{{ item.publishDate | yymmdd }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 四大专栏入口 -->
    <div class="columns">
      <div class="columns-inner">
        <div class="columns-head">
          <h3>协会专栏</h3>
          <p><span>SPECIAL</span> <span class="green">COLUMNS</span></p>
        </div>

        <ul class="columns-grid">
          <li class="column-card" @click="goEchelon">
            <div class="col-top">
              <span class="col-ico ico-blue"><i class="el-icon-trophy"></i></span>
              <span class="col-arrow"><i class="el-icon-arrow-right"></i></span>
            </div>
            <h4>运动员梯队专栏</h4>
            <p class="col-en">ATHLETE ECHELON</p>
            <p class="col-desc">梯队选拔办法、入选名单、集训安排、晋升规则公示</p>
          </li>

          <li class="column-card" @click="goCertificate">
            <div class="col-top">
              <span class="col-ico ico-green"><i class="el-icon-medal"></i></span>
              <span class="col-arrow"><i class="el-icon-arrow-right"></i></span>
            </div>
            <h4>裁判&教练员资质专栏</h4>
            <p class="col-en">REFEREE & COACH</p>
            <p class="col-desc">持证裁判员、教练员名录公示，可核验证书真伪</p>
          </li>

          <li class="column-card" @click="goKnowledge">
            <div class="col-top">
              <span class="col-ico ico-teal"><i class="el-icon-reading"></i></span>
              <span class="col-arrow"><i class="el-icon-arrow-right"></i></span>
            </div>
            <h4>科学科普/训练干货</h4>
            <p class="col-en">TRAINING GUIDE</p>
            <p class="col-desc">跳绳基础训练、速度跳教程、青少年体能提升方案</p>
          </li>

          <li class="column-card" @click="goCertApply">
            <div class="col-top">
              <span class="col-ico ico-amber"><i class="el-icon-document"></i></span>
              <span class="col-arrow"><i class="el-icon-arrow-right"></i></span>
            </div>
            <h4>证书管理入口</h4>
            <p class="col-en">CERTIFICATE SERVICE</p>
            <p class="col-desc">运动员/裁判员/教练员证线上申领、补办、年审</p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 成果展示（滚动照片） -->
    <div class="achievementinfo">
      <div class="ach-wrap">
        <div class="ach-marquee" v-if="achievementList.length > 0">
          <div class="ach-track">
            <div class="ach-item" v-for="a in achievementList" :key="a.id">
              <img :src="a.image" :alt="a.title" />
              <span class="ach-title">{{ a.title }}</span>
            </div>
            <div class="ach-item" v-for="a in achievementList" :key="'dup-' + a.id">
              <img :src="a.image" :alt="a.title" />
              <span class="ach-title">{{ a.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="partinfo">
      <p>沈阳市跳绳协会合作伙伴</p>
      <!-- <p>Cooperative partner  OOPERATIVE PARTNER</p> -->
      <p>COOPERATIVE PARTNER</p>
    </div>

    <!-- 底部轮播图  -->
    <div class="footerinfo">
      <ul class="footul">
        <li
          class="footli cursorPointer"
          v-for="item in imgtwo"
          :key="item.id"
          @click="toLink(item.linkPath)"
        >
          <img :src="item.imgPath" alt="" />
          <span class="partnerName">{{ item.partnerName }}</span>
        </li>
      </ul>

      <!-- <div class="prev" @click='go("prev")'>
        <button><i class="el-icon-arrow-left"></i></button>
      </div>
      <div>
        <el-carousel ref="cardshow" height="150px" :autoplay = "true" :interval="4000" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgtwo" :key="item.id" >
            <img :src="item.src" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="next" @click='go("next")'>
        <button><i class="el-icon-arrow-right"></i></button>
      </div> -->
      <a
        ref="aclick"
        v-show="false"
        target="_blank"
        href="https://www.chesscoacher.com/"
        >众弈世界</a
      >
    </div>
  </div>
</template>

<script>
  import request from '../utils/request'
  export default {
    name: 'Home',
    components: {},
    data() {
      return {
        noticelist: [
        ], //协会公告
        newslist: [], //新闻资讯
        // banner虚拟数据
        imgone: [],
        // 成果展示
        achievementList: [],

        // 底部合作伙伴
        imgtwo: [

          {
            id: 2,
            name: "优尔",
            src: require("@/assets/bannerall/yr.png")
          },
          {
            id: 4,
            name: "众弈",
            src: require("@/assets/bannerall/zy.png")
          },
          {
            id: 5,
            name: "跳绳俱乐部",
            src: require("@/assets/bannerall/mf.png")
          },
          {
            id: 3,
            name: "沈阳棋院",
            src: require("@/assets/bannerall/syqy.png")
          },

          {
            id: 1,
            name: "基金会",
            src: require("@/assets/bannerall/jjh.png")
          },
        ],
      }
    },
    created() {
      this.$store.commit("updatetabIndexActive", "1")
      // 进入页面 就将页面滚动到最顶部   可以解决多个路由页面共用一个滚动容器的bug
      document.documentElement.scrollTop = 0
      // 请求banner数据
      this.getbanner()
      // 请求partner数据
      this.getPartner()
      // 请求协会公告列表
      this.getnoticedata()
      // 请求新闻资讯列表
      this.getnewsdata()
      // 请求成果展示
      this.getAchievements()
      // 测试数组截取
      // this.handlelist()
    },

    methods: {
      // 获取成果展示
      async getAchievements() {
        try {
          const { data } = await request({
            method: 'get',
            url: `/achievement/pub/list`,
            params: { pageNum: 1, pageSize: 50 }
          })
          this.achievementList = (data.code === 200 && data.rows) ? data.rows : []
        } catch (e) {
          this.achievementList = []
        }
      },
      // 悬浮成绩查询
      queryList() {

        // 跳转至赛事活动页
        this.$router.push({
          name: "move",
          query: {
            queryRandomNum: 1
          }
        })
        this.$store.commit("updatetabIndexActive", "3")

      },
      // 获取协会公告列表
      async getnoticedata() {
        try {
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/NoticeInfo/list`,
          })
          if (data.code === 200 && data.rows) {
            this.noticelist = data.rows.slice(0, 5) //截取前五项
          } else {
            if (data.msg) {
              this.$message.error(data.msg);
              return
            }
            this.$message.error("获取赛事列表失败")
          }
        } catch (error) {
          this.$message.error("数据请求失败，请重试")
        }

      },
      // 获取新闻资讯列表
      async getnewsdata() {
        try {
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/NewsInfo/list`,
          })
          if (data.code === 200 && data.rows) {
            if (data.rows.length < 5) {
              this.newslist = data.rows
            } else {
              this.newslist = data.rows.slice(0, 5)
            }
          } else {
            this.newslist = []
          }
        } catch (e) {
          this.newslist = []
        }
      },

      async getnoticedetailsdata(item) {
        // 请求列表详情数据
        const { data } = await request({
          method: "POST",
          url: `/common/NoticeInfo/getInfo`,
          params: { id: item.noticeId }
        })
        // 存入vuex
        if (data.data) {
          await this.$store.commit("updateNoticedetails", data.data)
        } else {
          await this.$store.commit("updateNoticedetails", {})
        }
        // 将 index索引值存入vuex
        this.$store.commit("updatetabIndexActive", "2")
        document.documentElement.scrollTop = 0
        // 跳转路由
        this.$router.push({ path: '/Noticedetails' })
      },
 async getnewsdetailsdata(obj) {
        if(obj.newsLink) {
      // 如果有新闻链接 则直接跳转
      window.open(obj.newsLink, "_blank");
      } else {
        // 请求列表详情数据
        const {
          data
        } = await request({
          method: "POST",
          url: `/common/NewsInfo/getInfo`,
          params: {
            id: obj.newId
          }
        })
        console.log("获取新闻详情成功")
        console.log(data.data)
        // 存入vuex
        if (data.data) {
          // 如果详情对象有值 则将该机构详情对象数据存储到vuex中 供机构详情页使用
          await this.$store.commit("updatenewsdetails", data.data)
        } else {
          // 如果详情对象无值 则传入空对象
          await this.$store.commit("updatenewsdetails", {})
        }
        // 将 index索引值存入vuex
        this.$store.commit("updatetabIndexActive", "4")
        // 跳转路由
        this.$router.push({
          path: '/newsdetails'
        })
      }
      },

      // 获取banner图
      async getbanner() {
        try {
          const {
            data
          } = await request({
            url: `/common/BannerInfo/list`,
            method: "POST",
            params:{
            client:'pc'
          }
          })
          if (data.code === 200 && data.rows) {
            this.imgone = data.rows
          } else {
            if (data.msg) {
              this.$message.error(data.msg);
              return
            }
            this.$message.error("获取数据失败")
          }

        } catch (error) {
          this.$message.error("数据请求失败，请重试")
        }

      },
      // 获取合作伙伴图
      async getPartner() {
        try {
          const {
            data
          } = await request({
            url: `/common/partner/list`,
            method: "GET",
          })
          if (data.code === 200 && data.rows) {
            this.imgtwo = data.rows
          } else {
            if (data.msg) {
              this.$message.error(data.msg);
              return
            }
            this.$message.error("获取数据失败")
          }

        } catch (error) {
          this.$message.error("数据请求失败，请重试")
        }

      },




      tonotice() {
        // 先滚动置0 再跳转路由
        document.documentElement.scrollTop = 0
        this.$store.commit("updatetabIndexActive", "2")
        this.$router.push({
          path: "/Notice"
        })
      },
      tonews() {
        // 先滚动置0 再跳转路由
        document.documentElement.scrollTop = 0
        this.$store.commit("updatetabIndexActive", "4")
        this.$router.push({
          path: "/news"
        })
      },
      goEchelon() {
        this.$router.push('/echelon')
      },
      goCertificate() {
        this.$router.push('/certificate')
      },
      goKnowledge() {
        this.$router.push('/knowledge')
      },
      goCertApply() {
        this.$router.push('/certApply')
      },
      // 轮播图点击跳转事件
      go(type) {
        if (type === "prev") {
          this.$refs.cardshow.prev()
        } else {
          this.$refs.cardshow.next()
        }
      },
      // 轮播图点击跳转
      topage(item) {
        document.documentElement.scrollTop = 0
        window.open(item.linkPath)
        // if (id == 1) {
        //   document.documentElement.scrollTop = 0
        //   this.$router.push({ path: "/Notice" })
        //   this.$store.commit("updatetabIndexActive", "2")
        // }
        // if (id == 3) {
        //   document.documentElement.scrollTop = 0
        //   // 调用a链接（众弈世界）的点击事件
        //   this.$refs.aclick.click()
        // }
        // if (id == 2 || id == 4) {
        //   document.documentElement.scrollTop = 0
        //   this.$router.push({ path: "/move" })
        //   this.$store.commit("updatetabIndexActive", "3")
        // }
      },
      //合作伙伴跳转  window.location.href = "https://www.sport.gov.cn/"
      toLink(name) {
        window.open(name)
      },
    },
  }

</script>

<style lang="less" scoped>
.queryFixed {
  position: fixed;
  left: 5px;
  top: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  background-color: var(--ts-primary);
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.queryFixed:hover {
  background-color: var(--ts-primary-hover);
}

// #FE80B1, #1E40AF
// .home{
//background-color: #EFEFEF;
// }
.green {
  color: var(--ts-accent);
}

// 顶部轮播图样式
.maininfo {
  display: flex;
  justify-content: center;
  background-color: #fff;
}

.el-carousel__item img {
  width: 100%;
}

::v-deep .el-carousel__container {
  width: 100%;
  max-width: 1440px;
  height: 375px;
  // width: 1920px;
  // min-height: 600px;
}

/deep/ .maininfo .el-carousel__arrow--left {
  width: 40px;
}

/deep/ .maininfo .el-carousel__arrow--right {
  width: 40px;
}

/deep/ .maininfo .el-icon-arrow-left {
  font-size: 30px;
}

/deep/ .maininfo .el-icon-arrow-right {
  font-size: 30px;
}

// 顶部轮播图样式

// 公告新闻列表样式↓↓↓
.listinfo {
  background-color: #ffffff;
  margin: 25px 0px;
  height: 570px;
  padding: 45px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.widthSet {
  width: 100%;
  max-width: 1440px;
  display: flex;
  justify-content: space-between;
}

@keyframes myfirst {
  0% {
    opacity: 0;
    margin-top: 150px;
  }

  25% {
  }

  50% {
  }

  75% {
  }

  100% {
    margin-top: 0px;
    //  transform:rotateY(180deg);
    //  -webkit-transform: rotateY(360deg); /* Safari 与 Chrome */
    //  opacity: 1;
  }
}

.left,
.right {
  animation: myfirst 1.5s;
  -moz-animation: myfirst 1.5s;
  /* Firefox */
  -webkit-animation: myfirst 1.5s;
  /* Safari and Chrome */
  -o-animation: myfirst 1.5s;
  /* Opera */
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 580px;
}

.leftson {
  text-align: start;
}

.leftson h3 {
  font-size: 30px;
}

.leftson p {
  font-size: 24px;
  font-weight: bold;
}

.rightson {
  display: flex;
  align-items: center;
}

.rightson p {
  font-size: 20px;
  margin-right: 6px;
  font-weight: bold;
}

.rightson button {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid var(--ts-primary);
  background-color: white;

  i {
    padding-top: 2px;
    padding-left: 2px;
  }
}

.newnotice {
  margin: 20px 0px 30px;
}

.newnotice li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 0px 20px;
  // width: 650px;
  height: 60px;
  font-size: 20px;
  color: var(--ts-on-primary);
  background-color: var(--ts-primary);
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.newnotice li:hover {
  background-color: var(--ts-primary-hover);
  transform: translateY(-2px);
}

// .newnotice li:last-child {
//   margin-bottom: 0px;
// }

// 公告新闻列表样式↑↑↑

// 成果展示（滚动照片） ↓↓↓
.achievementinfo {
  background-color: #ffffff;
  margin: 25px 0px;
  padding: 35px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ach-wrap {
  width: 100%;
  max-width: 1440px;
}

.ach-marquee {
  overflow: hidden;
}

.ach-track {
  display: flex;
  gap: 16px;
  width: max-content;
  animation: achScroll 30s linear infinite;
}

@keyframes achScroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.ach-marquee:hover .ach-track {
  animation-play-state: paused;
}

.ach-item {
  width: 320px;
  flex-shrink: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 320px;
    object-fit: cover;
    display: block;
  }

  .ach-title {
    display: block;
    padding: 8px 12px;
    font-size: 15px;
    color: #333;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

// 成果展示（滚动照片） ↑↑↑

// 四大专栏入口 ↓↓↓
.columns {
  background: linear-gradient(180deg, #f4f7ff 0%, #ffffff 100%);
  margin: 25px 0px;
  padding: 50px 0px;
  display: flex;
  justify-content: center;
}

.columns-inner {
  width: 100%;
  max-width: 1440px;
}

.columns-head {
  text-align: center;
  margin-bottom: 36px;

  h3 {
    font-size: 32px;
    color: var(--ts-text);
  }

  p {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
    color: var(--ts-muted);
    margin-top: 4px;
  }
}

.columns-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.column-card {
  position: relative;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #eef2fb;
  border-radius: 16px;
  padding: 28px 26px 26px;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(30, 64, 175, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, var(--ts-primary), var(--ts-secondary));
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 18px 36px rgba(30, 64, 175, 0.16);

    &::after {
      opacity: 1;
    }

    .col-arrow {
      background: var(--ts-primary);
      border-color: var(--ts-primary);
      color: #fff;
      transform: translateX(2px);
    }
  }
}

.col-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.col-ico {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: 30px;
    color: #ffffff;
  }
}

.ico-blue { background: linear-gradient(135deg, #2563eb, #3b82f6); }
.ico-green { background: linear-gradient(135deg, #16a34a, #4ade80); }
.ico-teal { background: linear-gradient(135deg, #0d9488, #2dd4bf); }
.ico-amber { background: linear-gradient(135deg, #d97706, #fbbf24); }

.col-arrow {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--ts-muted);
  transition: all 0.3s ease;

  i {
    font-size: 16px;
  }
}

.column-card h4 {
  font-size: 20px;
  font-weight: 700;
  color: var(--ts-text);
}

.col-en {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: var(--ts-muted);
  margin-top: 4px;
  text-transform: uppercase;
}

.col-desc {
  font-size: 14px;
  line-height: 1.6;
  color: var(--ts-muted);
  margin-top: 12px;
  min-height: 44px;
}

// 专栏入口响应式
@media (max-width: 1000px) {
  .columns-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .columns-grid {
    grid-template-columns: 1fr;
  }
}
// 四大专栏入口 ↑↑↑

// 合作伙伴 ↓↓↓
.partinfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 150px;
  background-image: url(../assets/css/img/bg.jpg);
}

.partinfo p {
  font-size: 35px;
  color: #ffffff;
}

.partinfo p:last-child {
  font-size: 24px;
}

// 合作伙伴 ↑↑↑

// 底部轮播图待替换 ↓↓↓
.footerinfo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 260px;
  background-color: #ffffff;

  margin: 25px 0px;
}

// 静态ul li
.footul {
  height: 220px;
  display: flex;
  width: 100%;
  max-width: 1440px;
  // justify-content: flex-start;
}

.footli {
  background-color: white;
  height: 220px;
  width: 240px;
  // width: 100px;
  display: flex;
  flex-direction: column;
  // align-items: flex-end;
  align-items: center;
  justify-content: center;

  .partnerName {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
    text-align: center;
  }
}

.footli img {
  width: 190px;
  -webkit-transition: width 0.8s;
  /* For Safari 3.1 to 6.0 */
  transition: width 0.8s;
}

.footli img:hover {
  width: 240px;

  // background-image: linear-gradient(to right, #FE80B1,rgba(0,0,0,0) , #1E40AF,);
}

.footli:hover {
  border-bottom: 2px solid var(--ts-primary);
}

// 轮播图
.footerinfo .prev {
  width: 60px;
  height: 60px;
  border: 1px solid white;
  margin-right: 109px;
  line-height: 60px;
}

.footerinfo .prev .el-icon-arrow-left {
  font-size: 20px;
}

.footerinfo .next {
  width: 60px;
  height: 60px;
  border: 1px solid white;
  margin-left: 109px;
  line-height: 60px;
}

.footerinfo .next .el-icon-arrow-right {
  font-size: 20px;
}

.footerinfo .prev button,
.footerinfo .next button {
  width: 60px;
  height: 60px;
}

// 轮播图具体样式  轮播图样式调整思路
// 标签上的高度、.el-carousel的宽度、.el-carousel__item及.el-carousel__container的宽高
.footerinfo .el-carousel {
  width: 260px;
}

//  .footerinfo .el-carousel .el-carousel__item{
//   //  height: 100px;
//   //  width: 100px;
//  }

// 底部轮播图 待替换↑↑↑
.maxwidth {
  width: 400px;
  text-align: left;
  widows: 100%;
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>
